var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{attrs:{"value":true,"transition":"none","max-width":"800"},on:{"click:outside":_vm.closeDialog}},[_c('v-card',{staticClass:"pa-5",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('v-btn',{staticClass:"close-icon",attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',[_vm._v("mdi-close-thick")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }